'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var determineAspectRatio = function determineAspectRatio(props) {
  if (props.aspectRatio) {
    return props.aspectRatio;
  } else if (props.image.preferredAspectRatio) {
    return false;
  } else if (props.image && props.image.preferred_aspect_ratio_slug) {
    return props.image.preferred_aspect_ratio_slug;
  } else {
    // console.warn(
    //   "We did not find the aspect ratio asked for. We are sending back 'uncropped' so you will get the uncropped aspect ratio if you have that in your graphql query and if not the fallback image."
    // )
    return 'uncropped';
  }
};

var generateSrcSet = function generateSrcSet(instances) {
  var typeRegex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /jpe?g$/;
  var rightones = instances.map(function (inst) {
    return typeRegex.test(inst.url) ? inst : null;
  });
  return rightones.filter(Boolean).map(function (instance) {
    return "".concat(instance.url, " ").concat(instance.width, "w");
  }).join(',');
};

var hasWebp = function hasWebp(props) {
  var image = props.image;
  var flat = [];
  var ars;
  if (!image) return false;

  if (image.preferredAspectRatio) {
    image.preferredAspectRatio.instances.forEach(function (obj) {
      return flat.push(obj.url);
    });
  } else {
    ars = image.aspect_ratios;
    delete ars['__typename'];
    Object.keys(ars).forEach(function (ar) {
      var _ars$ar;

      (_ars$ar = ars[ar]) === null || _ars$ar === void 0 ? void 0 : _ars$ar.instances.forEach(function (img) {
        return flat.push(img.url);
      });
    });
  }

  return flat.some(function (url) {
    return /webp$/.test(url);
  });
};
var getSpecificInstance = function getSpecificInstance(props, aspectratio) {
  var typeRegex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : /jpe?g$/;
  var image = props.image;
  if (!image.aspect_ratios[aspectratio]) return null;
  return generateSrcSet(image.aspect_ratios[aspectratio].instances, typeRegex);
};
var getSrcSet = function getSrcSet(props) {
  var typeRegex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /jpe?g$/;
  if (!props) return null;
  var image = props.image,
      aspectRatio = props.aspectRatio,
      fallbackSrcSet = props.fallbackSrcSet;
  if (!image) return fallbackSrcSet || null; // if props.aspectRatio is passed in we want that aspect ration so return it first
  // before anything else happens

  if (image.aspect_ratios && determineAspectRatio(props) in image.aspect_ratios && image.aspect_ratios[aspectRatio] !== null) {
    return generateSrcSet(image.aspect_ratios[determineAspectRatio(props)].instances, typeRegex);
  }

  if (image.preferredAspectRatio) {
    return generateSrcSet(image.preferredAspectRatio.instances, typeRegex);
  }

  if (image.srcset) {
    return image.srcset;
  } else if (fallbackSrcSet) {
    return fallbackSrcSet;
  }
};
var getInstances = function getInstances(props) {
  if (!props) return [];
  var image = props.image,
      aspectRatio = props.aspectRatio;

  if (image) {
    if (image.aspect_ratios && determineAspectRatio(props) in image.aspect_ratios && image.aspect_ratios[aspectRatio] !== null) {
      return image.aspect_ratios[determineAspectRatio(props)].instances;
    } else if (image.preferredAspectRatio) {
      return image.preferredAspectRatio.instances;
    }
  }

  return [];
};
var getSrc = function getSrc(props) {
  if (!props) return [];
  var image = props.image,
      fallbackSrc = props.fallbackSrc;
  if (!image && fallbackSrc) return {
    url: fallbackSrc
  };
  if (!image) return [];

  if (image && image.fallback) {
    try {
      return image.preferredAspectRatio.instances.find(function (inst) {
        return inst.url == image.fallback;
      });
    } catch (_unused) {
      return {
        url: image.fallback
      }; //here we want to get the width and height of the image fallback
    }
  } else {
    // we can't find anything so try to use the preferred aspect ratio or the first aspect ratio that is present
    var instances;

    if (image.preferred_aspect_ratio_slug && image.aspect_ratios[image.preferred_aspect_ratio_slug]) {
      instances = image.aspect_ratios[image.preferred_aspect_ratio_slug].instances;
    } else {
      var _Object$values$find;

      instances = ((_Object$values$find = Object.values(image.aspect_ratios).find(function (value) {
        return value != null;
      })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.instances) || [];
    } // make sure we don't return a webp


    var inst = instances.find(function (img) {
      return img.url.match(/(jpe?g|gif|png)\??(s=[0-9]+)?$/);
    });
    return inst;
  }
};
var getAlt = function getAlt(props) {
  if (!props) return [];
  var alt = props.alt,
      image = props.image;

  if (alt) {
    return alt;
  } else if (image && image.short_caption) {
    return image.short_caption;
  } else {
    return '';
  }
};

function ext(url) {
  if (typeof url != 'string') return '';
  var extension; // Remove everything to the last slash in URL

  extension = url.substr(1 + url.lastIndexOf('.')); // Break URL at ? and take first part (file name, extension)

  extension = extension.split('?')[0]; // Sometimes URL doesn't have ? but #, so we should aslo do the same for #

  extension = extension.split('#')[0]; // Now we have only extension

  return extension;
}

function SourceEle(props) {
  return /*#__PURE__*/React.createElement("source", props);
}

var Image = function Image(props) {
  var fallbackImage = getSrc(props);
  var extension = ext(fallbackImage.url);
  var haswebp = hasWebp(props);
  var regexes = {
    jpg: /jpe?g\??(s=[0-9]+)?$/,
    jpeg: /jpe?g\??(s=[0-9]+)?$/,
    webp: /webp\??(s=[0-9]+)?$/,
    gif: /gif\??(s=[0-9]+)?$/,
    png: /png\??(s=[0-9]+)?$/
  };
  var fallbackImageProps = {
    src: fallbackImage.url,
    loading: props.loading
  };
  if (fallbackImage.width) fallbackImageProps.width = fallbackImage.width;
  if (fallbackImage.height) fallbackImageProps.height = fallbackImage.height; // We need a <source> element for each props.media for webp  and the same for non webp
  // So if there are 2 items in props.media and we have webp image there will be 3 <source> elements

  if (props.media) {
    return /*#__PURE__*/React.createElement("picture", {
      className: props.elementClass,
      "data-testid": "picture"
    }, hasWebp && props.media.map(function (med, idx) {
      return SourceEle({
        type: 'image/webp',
        key: "webp-".concat(idx),
        srcSet: idx == 0 ? getSpecificInstance(props, props.mobileAr, regexes.webp) // only get the mobile art directed aspect ratio on the first media array item
        : getSrcSet(props, regexes.webp),
        sizes: props.sizes,
        'data-testid': 'webp',
        media: "(".concat(med, ")")
      });
    }), props.media.map(function (med, idx) {
      return SourceEle({
        type: "image/".concat(extension).replace(/jpg$/, 'jpeg'),
        key: "nonwebp-".concat(idx),
        srcSet: idx == 0 ? getSpecificInstance(props, props.mobileAr, regexes[extension]) : getSrcSet(props, regexes[extension]),
        sizes: props.sizes,
        'data-testid': 'notwebp',
        media: "(".concat(med, ")")
      });
    }), /*#__PURE__*/React.createElement("img", _extends({}, fallbackImageProps, {
      alt: getAlt(props)
    })));
  }

  return /*#__PURE__*/React.createElement("picture", {
    className: props.elementClass,
    "data-testid": "picture"
  }, haswebp && /*#__PURE__*/React.createElement(SourceEle, {
    type: "image/webp",
    srcSet: getSrcSet(props, regexes.webp),
    sizes: props.sizes,
    "data-testid": "webp"
  }), /*#__PURE__*/React.createElement(SourceEle, {
    type: "image/".concat(extension).replace(/jpg$/, 'jpeg'),
    srcSet: getSrcSet(props, regexes[extension]),
    sizes: props.sizes,
    "data-testid": "notwebp"
  }), /*#__PURE__*/React.createElement("img", _extends({}, fallbackImageProps, {
    alt: getAlt(props)
  })));
};

var aspectRatioType = PropTypes.shape({
  instances: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
  })),
  slug: PropTypes.string
});
Image.propTypes = {
  image: PropTypes.shape({
    preferredAspectRatio: aspectRatioType,
    aspect_ratios: PropTypes.shape({
      normal: aspectRatioType,
      square: aspectRatioType,
      thumbnail: aspectRatioType,
      widescreen: aspectRatioType,
      portrait: aspectRatioType,
      uncropped: aspectRatioType
    }),
    fallback: PropTypes.string.isRequired,
    long_caption: PropTypes.string,
    short_caption: PropTypes.string,
    width: PropTypes.string,
    preferred_aspect_ratio_slug: PropTypes.string,
    id: PropTypes.string,
    url: PropTypes.string,
    srcset: PropTypes.string
  }),
  aspectRatio: PropTypes.oneOf(['normal', 'square', 'thumbnail', 'widescreen', 'portrait', 'uncropped']),
  elementClass: PropTypes.string,
  fallbackSrcSet: PropTypes.string,
  fallbackSrc: PropTypes.string,
  alt: PropTypes.string,
  sizes: PropTypes.string,
  loading: PropTypes.string,
  media: PropTypes.array,
  mobileAr: PropTypes.string,
  mustProvideOne: function mustProvideOne(props) {
    if (!props['image'] && !props['fallbackSrc']) {
      return new Error('Please provide either a properly formatted image JSON object or an image src');
    }
  },
  mustProvideAlt: function mustProvideAlt(props) {
    if (!props['image'] && !props['alt'] && props['alt'] !== '') {
      return new Error('Please provide either a properly formatted image JSON object or an image alt');
    }
  },
  mustProvideSrcWithSrcset: function mustProvideSrcWithSrcset(props) {
    if (!props['image'] && !props['fallbackSrc'] && props['fallbackSrcSet']) {
      return new Error('You cannot provide a fallbackSrcSet without providing a fallbackSrc');
    }
  }
};
Image.defaultProps = {
  elementClass: ''
};

var ampStyles = {
  image: {
    maxWidth: '100%'
  }
};

var AmpImage = function AmpImage(props) {
  var fallbackImage = getSrc(props);
  var instances = getInstances(props);

  var _ref = instances[0] || {
    height: false,
    width: false
  },
      height = _ref.height,
      width = _ref.width;

  if (height && width) {
    return /*#__PURE__*/React.createElement("amp-img", {
      style: ampStyles.image,
      class: props.elementClass,
      src: fallbackImage.url,
      alt: getAlt(props),
      srcSet: getSrcSet(props),
      sizes: props.sizes,
      height: height,
      width: width,
      layout: "responsive"
    });
  }

  return /*#__PURE__*/React.createElement("amp-img", {
    style: ampStyles.image,
    class: props.elementClass,
    src: fallbackImage.url,
    alt: getAlt(props),
    srcSet: getSrcSet(props),
    height: props.fallbackHeight ? props.fallbackHeight : '225',
    width: props.fallbackWidth ? props.fallbackWidth : '400',
    sizes: props.sizes,
    layout: "responsive"
  });
};

var aspectRatioType$1 = PropTypes.shape({
  instances: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
  })),
  slug: PropTypes.string
});
AmpImage.propTypes = {
  image: PropTypes.shape({
    preferredAspectRatio: aspectRatioType$1,
    aspect_ratios: PropTypes.shape({
      normal: aspectRatioType$1,
      square: aspectRatioType$1,
      thumbnail: aspectRatioType$1,
      widescreen: aspectRatioType$1,
      portrait: aspectRatioType$1,
      uncropped: aspectRatioType$1
    }),
    fallback: PropTypes.string.isRequired,
    long_caption: PropTypes.string,
    short_caption: PropTypes.string,
    width: PropTypes.string,
    preferred_aspect_ratio_slug: PropTypes.string,
    id: PropTypes.string,
    url: PropTypes.string,
    srcset: PropTypes.string
  }),
  aspectRatio: PropTypes.oneOf(['normal', 'square', 'thumbnail', 'widescreen', 'portrait', 'uncropped']),
  elementClass: PropTypes.string,
  fallbackSrcSet: PropTypes.string,
  fallbackSrc: PropTypes.string,
  alt: PropTypes.string,
  sizes: PropTypes.string,
  fallbackHeight: PropTypes.string,
  fallbackWidth: PropTypes.string,
  mustProvideOne: function mustProvideOne(props) {
    if (!props['image'] && !props['fallbackSrc']) {
      return new Error('Please provide either a properly formatted image JSON object or an image src');
    }
  },
  mustProvideAlt: function mustProvideAlt(props) {
    if (!props['image'] && !props['alt'] && props['alt'] !== '') {
      return new Error('Please provide either a properly formatted image JSON object or an image alt');
    }
  },
  mustProvideSrcWithSrcset: function mustProvideSrcWithSrcset(props) {
    if (!props['image'] && !props['fallbackSrc'] && props['fallbackSrcSet']) {
      return new Error('You cannot provide a fallbackSrcSet without providing a fallbackSrc');
    }
  }
};
AmpImage.defaultProps = {
  elementClass: ''
};

exports.AmpImage = AmpImage;
exports.Image = Image;
